import { createContext } from 'react';

export type PageMetaContext = {
  pageUrl: string;
  isInvite: boolean;
  isPreview: boolean;
  currentUrl: string;
  pageType: string;
  pageShortName: string;
  pageSlug: string;
  metaTagImageUrl?: string;
  metaTagDescription?: string;
  error?: {
    status: number;
    messageKey: string;
  };
  showBanner?: boolean;
  bannerCopy?: string;
};

export const PageMetaContext = createContext<PageMetaContext | null>(null);

export const PageMetaContextProvider = PageMetaContext.Provider;
